import React from "react";
import { FaNetworkWired, FaServer, FaShieldHalved } from "react-icons/fa6";
import banner3 from "../assets/banner3.jpg";

export default function SolarRenewable() {
  const features = [
    {
      icon: <FaNetworkWired size={20} className="text-primary" />,
      text: "Network design and implementation that supports stable connectivity across sites, teams, and services.",
    },
    {
      icon: <FaServer size={20} className="text-primary" />,
      text: "Infrastructure planning that balances performance, scalability, and maintainability.",
    },
    {
      icon: <FaShieldHalved size={20} className="text-primary" />,
      text: "Foundational environments built with reliability and secure operations in mind.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Network Infrastructure Solutions</h2>
          <p className="section-copy">
            Nova Technologies designs and improves digital infrastructure that keeps
            organizations connected, responsive, and ready to scale.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner3} alt="Network Infrastructure Solutions" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Strong infrastructure is essential to reliable operations. Nova helps clients
            shape network environments that support business continuity, user access, and
            future digital growth without unnecessary complexity.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Assess current infrastructure and identify critical gaps.</li>
            <li>Design fit-for-purpose network and connectivity improvements.</li>
            <li>Implement and optimize the environment for reliability and usability.</li>
            <li>Support long-term maintenance and infrastructure evolution.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
